import _ from 'underscore';
import {
  setConfig,
  show,
  showError,
  showWarning,
  showInfo,
  showConfirmation,
  dismiss,
  dismissAll,
  newAlertId,
  toastError,
  toastWarning,
  toastInfo,
  toastConfirmation,
} from '@bingads-webui-react/floating-banner';

export type FloatingBannerMessage = Parameters<typeof showError>[0];

export interface LegacyFloatingBannerAlert {
  Message: FloatingBannerMessage;
}

const appendError = (errors?: LegacyFloatingBannerAlert[]) => {
  if (_.isArray(errors) && !_.isEmpty(errors) && errors[0].Message) {
    showError(errors[0].Message);
  }
};

const appendWarning = (warnings?: LegacyFloatingBannerAlert[]) => {
  if (_.isArray(warnings) && !_.isEmpty(warnings) && warnings[0].Message) {
    showWarning(warnings[0].Message);
  }
};

const appendInfo = (info?: LegacyFloatingBannerAlert) => {
  if (_.isObject(info) && info.Message) {
    showInfo(info.Message);
  }
};

const appendSuccess = (confirmation?: LegacyFloatingBannerAlert) => {
  if (_.isObject(confirmation) && confirmation.Message) {
    showConfirmation(confirmation.Message);
  }
};

const appendErrorMessage = (errorMessage: FloatingBannerMessage) => {
  showError(errorMessage);
};

const appendWarningMessage = (warningMessage: FloatingBannerMessage) => {
  showWarning(warningMessage);
};

const appendInfoMessage = (infoMessage: FloatingBannerMessage) => {
  showInfo(infoMessage);
};

const appendSuccessMessage = (confirmationMessage: FloatingBannerMessage) => {
  showConfirmation(confirmationMessage);
};

export {
  setConfig,
  appendError,
  appendWarning,
  appendInfo,
  appendSuccess,
  appendErrorMessage,
  appendWarningMessage,
  appendInfoMessage,
  appendSuccessMessage,
  show,
  showError,
  showWarning,
  showInfo,
  showConfirmation,
  dismiss,
  dismissAll,
  newAlertId,
  toastError,
  toastWarning,
  toastInfo,
  toastConfirmation,
};
